__turbopack_context__.v({
  "brand-text-container": "a9fGWq_brand-text-container",
  "contact": "a9fGWq_contact",
  "contact-headline": "a9fGWq_contact-headline",
  "contact-link": "a9fGWq_contact-link",
  "contact-opening-hours": "a9fGWq_contact-opening-hours",
  "footer": "a9fGWq_footer",
  "footer-section": "a9fGWq_footer-section",
  "home-link": "a9fGWq_home-link",
  "mapper-a": "a9fGWq_mapper-a",
  "mapper-p": "a9fGWq_mapper-p",
  "menu": "a9fGWq_menu",
  "placeholder": "a9fGWq_placeholder",
  "primary-nav": "a9fGWq_primary-nav",
  "primary-nav-headline": "a9fGWq_primary-nav-headline",
  "primary-nav-item": "a9fGWq_primary-nav-item",
  "primary-nav-menu": "a9fGWq_primary-nav-menu",
  "teaser": "a9fGWq_teaser",
});
